import React, { useState } from 'react';
import { FaSave, FaEdit } from 'react-icons/fa';

const GavachiMulbhutMahiti = () => {
  const [isEditing, setIsEditing] = useState(false);
  
  const [data, setData] = useState({
    // Basic Details
    villageName: '',
    taluka: '',
    district: '',
    state: 'महाराष्ट्र',
    pincode: '',
    
    // Population
    totalPopulation: '',
    malePopulation: '',
    femalePopulation: '',
    kidsSentors: '',
    
    // Houses
    totalHouses: '',
    pakkaHouses: '',
    kachhaHouses: '',
    
    // Land
    totalArea: '',
    agriArea: '',
    irrigatedLand: '',
    nonIrrigatedLand: '',
    barrenLand: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const calculateTotalPop = () => {
      // Auto calculate total if needed, or just let user input
  };

  const handleSave = () => {
    // Logic to save data to backend/firebase
    console.log('Saved Data:', data);
    setIsEditing(false);
    alert('गावाची मूलभूत माहिती यशस्वीरित्या सेव्ह केली!');
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex justify-between items-center mb-6 border-b pb-4">
        <h2 className="text-2xl font-bold text-[#267c77]">गावाची मूलभूत माहिती</h2>
        <button
          onClick={() => isEditing ? handleSave() : setIsEditing(true)}
          className={`flex items-center space-x-2 px-6 py-2 rounded-lg font-medium transition-colors ${
            isEditing 
              ? 'bg-[#267c77] text-white hover:bg-[#1e635f]' 
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {isEditing ? <FaSave /> : <FaEdit />}
          <span>{isEditing ? 'माहिती सेव्ह करा' : 'माहिती अपडेट करा'}</span>
        </button>
      </div>

      <div className="space-y-8">
        {/* Basic Details Section */}
        <section>
          <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span className="w-1 h-6 bg-[#267c77] rounded mr-2"></span>
            मूलभूत माहिती (Basic Details)
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">गावाचे नाव</label>
              <input
                type="text"
                name="villageName"
                value={data.villageName}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">तालुका</label>
              <input
                type="text"
                name="taluka"
                value={data.taluka}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">जिल्हा</label>
              <input
                type="text"
                name="district"
                value={data.district}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">राज्य</label>
              <input
                type="text"
                name="state"
                value={data.state}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">पिनकोड</label>
              <input
                type="text"
                name="pincode"
                value={data.pincode}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
          </div>
        </section>

        {/* Population Info */}
         <section>
          <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span className="w-1 h-6 bg-[#267c77] rounded mr-2"></span>
            लोकसंख्या माहिती (Population Info)
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-blue-50 p-4 rounded-xl border border-blue-100">
              <label className="block text-sm font-bold text-blue-800 mb-1">एकूण लोकसंख्या</label>
              <input
                type="number"
                name="totalPopulation"
                value={data.totalPopulation}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2 bg-white border border-blue-200 rounded text-lg font-semibold text-blue-900 focus:ring-2 focus:ring-blue-400 disabled:bg-transparent"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">पुरुष संख्या</label>
              <input
                type="number"
                name="malePopulation"
                value={data.malePopulation}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">महिला संख्या</label>
              <input
                type="number"
                name="femalePopulation"
                value={data.femalePopulation}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">मुले / ज्येष्ठ नागरिक संख्या</label>
              <input
                type="number"
                name="kidsSentors"
                value={data.kidsSentors}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
          </div>
        </section>

        {/* House Info */}
        <section>
          <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span className="w-1 h-6 bg-[#267c77] rounded mr-2"></span>
            घरांची माहिती (Houses Info)
          </h3>
           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100">
              <label className="block text-sm font-bold text-amber-800 mb-1">एकूण घरे</label>
              <input
                type="number"
                name="totalHouses"
                value={data.totalHouses}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2 bg-white border border-amber-200 rounded text-lg font-semibold text-amber-900 focus:ring-2 focus:ring-amber-400 disabled:bg-transparent"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">पक्की घरे</label>
              <input
                type="number"
                name="pakkaHouses"
                value={data.pakkaHouses}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">कच्ची घरे</label>
              <input
                type="number"
                name="kachhaHouses"
                value={data.kachhaHouses}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
          </div>
        </section>

        {/* Land Info */}
        <section>
          <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span className="w-1 h-6 bg-[#267c77] rounded mr-2"></span>
            जमीन माहिती (Land Info) in Hector/R
          </h3>
           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-green-50 p-4 rounded-xl border border-green-100">
              <label className="block text-sm font-bold text-green-800 mb-1">गावाचे एकूण क्षेत्रफळ</label>
              <input
                type="text"
                name="totalArea"
                value={data.totalArea}
                onChange={handleChange}
                disabled={!isEditing}
                placeholder="Ex. 1200 Hec"
                className="w-full p-2 bg-white border border-green-200 rounded text-lg font-semibold text-green-900 focus:ring-2 focus:ring-green-400 disabled:bg-transparent"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">शेती क्षेत्रफळ</label>
              <input
                type="text"
                name="agriArea"
                value={data.agriArea}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">सिंचित जमीन</label>
              <input
                type="text"
                name="irrigatedLand"
                value={data.irrigatedLand}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">बिनसिंचित जमीन</label>
              <input
                type="text"
                name="nonIrrigatedLand"
                value={data.nonIrrigatedLand}
                onChange={handleChange}
                disabled={!isEditing}
                className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
             <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">पडीत जमीन</label>
              <input
                type="text"
                name="barrenLand"
                value={data.barrenLand}
                onChange={handleChange}
                disabled={!isEditing}
                 className="w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#267c77] disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default GavachiMulbhutMahiti;
